const storage = {
  set(key: string, value: any) {
    localStorage.setItem(key, JSON.stringify(value));
  },
  get(key: string): any {
    const valueString = localStorage.getItem(key);
    if (valueString) {
      const valueJson: any = JSON.parse(valueString);
      return valueJson;
    }
  },
  remove(key: string) {
    localStorage.removeItem(key);
  },
};
export default storage;
